import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=15316ac6&scoped=true"
import script from "./userManagement.vue?vue&type=script&lang=js"
export * from "./userManagement.vue?vue&type=script&lang=js"
import style0 from "./userManagement.vue?vue&type=style&index=0&id=15316ac6&prod&lang=scss&scoped=true"
import style1 from "./userManagement.vue?vue&type=style&index=1&id=15316ac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15316ac6",
  null
  
)

export default component.exports